<template>
    <div :class="{'app-content': loggedIn}">
        <div v-if="loggedIn" class="menu-toggle-show" @click="showLeftMenu()"><img src="/images/svg/menu.svg" alt=""></div>

        <img v-if="!loggedIn" src="/images/svg/logo.svg" class="logo-main" alt="logo">
        <div v-if="!loggedIn" class="logo-grad-div"></div>

        <div class="app-alert"></div>

        <div class="menu-open-bg" v-if="showMenu" @click="hideLeftMenu()"></div>
        <div id="left-menu" v-if="loggedIn" :class="{'closed': !showMenu}">
            <div class="top-block" style="height: 110px;">
                <div class="menu-toggle-hide" @click="hideLeftMenu()"><img src="/images/svg/close.svg" alt=""></div>
                <img src="/images/svg/logo2.svg" alt="" @click="$router.push('/')" style="cursor: pointer">

                <div class="tabs">
                    <div class="tab home mod"
                         :class="{'active': showBuildingsList}"
                         @click="to('/building')"><span>Объекты</span></div>


                    <div class="tab profile mod"
                         :class="{'active': $route.path.startsWith('/profile')}"
                         @click="to('/profile')"><span>Профиль</span></div>
                </div>
            </div>

            <building-list v-if="showBuildingsList"></building-list>
            <profile-menu v-if="$route.path.startsWith('/profile')"></profile-menu>

        </div>

        <router-view></router-view>

        <my-popup v-model="showMobileAlert" title="" scroll="0" @close="hideMobileAlert(4)">
            <div class="app-links">
                <div class="title">
                    Скачайте наши <br> мобильные приложения:
                </div>
                <div class="links">
                    <a href="https://play.google.com/store/apps/details?id=com.daichi.control">
                        <svg focusable="false" class="svg-inline--fa fa-google-play fa-w-16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"></path></svg>
                        <div style="padding-top: 4px">Android</div>
                    </a>
                    <a href="https://apps.apple.com/ru/app/%D0%B4%D0%B0%D0%B8%D1%87%D0%B8-%D0%BA%D0%BE%D0%BC%D1%84%D0%BE%D1%80%D1%82/id1479877522">
                        <svg focusable="false" class="svg-inline--fa fa-app-store-ios fa-w-14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM127 384.5c-5.5 9.6-17.8 12.8-27.3 7.3-9.6-5.5-12.8-17.8-7.3-27.3l14.3-24.7c16.1-4.9 29.3-1.1 39.6 11.4L127 384.5zm138.9-53.9H84c-11 0-20-9-20-20s9-20 20-20h51l65.4-113.2-20.5-35.4c-5.5-9.6-2.2-21.8 7.3-27.3 9.6-5.5 21.8-2.2 27.3 7.3l8.9 15.4 8.9-15.4c5.5-9.6 17.8-12.8 27.3-7.3 9.6 5.5 12.8 17.8 7.3 27.3l-85.8 148.6h62.1c20.2 0 31.5 23.7 22.7 40zm98.1 0h-29l19.6 33.9c5.5 9.6 2.2 21.8-7.3 27.3-9.6 5.5-21.8 2.2-27.3-7.3-32.9-56.9-57.5-99.7-74-128.1-16.7-29-4.8-58 7.1-67.8 13.1 22.7 32.7 56.7 58.9 102h52c11 0 20 9 20 20 0 11.1-9 20-20 20z"></path></svg>
                        <div style="padding-top: 4px">IOS</div>
                    </a>
                </div>
                <div class="never-show" @click="hideMobileAlert(96)">Больше не показывать</div>
            </div>
        </my-popup>

    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import BuildingList from './leftMenu/building'
    import ProfileMenu from './leftMenu/profile'
    import MyPopup from './elements/popup'

    export default {
        components:{
            BuildingList,
            ProfileMenu,
            MyPopup,
        },
        data(){
            return {
                drawer: {
                    opened: null
                },
                showServConnection: true,
                showMobileAlert: true,
            };
        },
        methods:{
            logout(){
                this.$store.dispatch('logout');
            },
            openDrawer(){
                this.drawer.opened = true;
            },
            to(path){
                this.$router.push(path);
                this.hideLeftMenu();
            },
            toAddBuilding(){
                this.$router.push('/building/add');
                setTimeout(()=>{
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                }, 100)
                this.hideLeftMenu();
            },
            ...mapActions([
                'hideCtrlFailAlert',
                'showLeftMenu',
                'hideLeftMenu',
            ]),
            hideMobileAlert(hours){
                window.localStorage.setItem('hideMobileAlert', (new Date()).getTime() + hours * 3600 *1000)
                this.showMobileAlert = false
            }
        },
        created(){
            if(window.innerWidth > 600){
                this.showMobileAlert = false
                return
            }
            let ts = +window.localStorage.getItem('hideMobileAlert');
            let now = (new Date()).getTime()
            this.showMobileAlert = now > ts
        },
        watch:{
            mqttConnected(newVal, oldVal){
                if(newVal === true){
                    setTimeout(()=>{
                        this.showServConnection = false
                    }, 10000)
                } else {
                    this.showServConnection = true
                }
            }
        },
        computed:{
            ...mapState([
                'loggedIn',
                'mqttConnected',
                'user',
                'showMenu',
            ]),
            showBuildingsList(){
                return this.$route.name === 'building'
                    || this.$route.name === 'building-add'
                    || this.$route.name === 'building-selected'
                    || this.$route.name === 'device-add'
                    || this.$route.name === 'device'
            }
        }
    }
</script>
